import I18n from 'I18n';
import { SearchInput } from 'foundations-components/transitional/components/SearchInput';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { useMemo } from 'react';
import debounce from 'react-utils/debounce';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
const CardSearchInput = ({
  onSearchChange,
  placeholder
}) => {
  const searchPlaceholder = I18n.text(placeholder);
  const debouncedSearch = useMemo(() => debounce(e => {
    const search = e.target.value.trim();
    onSearchChange(search && search.length ? search : undefined);
  }, 400), [onSearchChange]);
  return /*#__PURE__*/_jsx(View, {
    backgroundColor: "fill-surface-raised",
    padding: "300",
    children: /*#__PURE__*/_jsx(FormControl, {
      "aria-label": searchPlaceholder,
      children: /*#__PURE__*/_jsx(SearchInput, {
        onChange: debouncedSearch,
        placeholder: searchPlaceholder,
        use: "on-dark"
      })
    })
  });
};
export default CardSearchInput;